import type { PolicyAttestationRecordsForDocumentResponseRow } from '@risksmart-app/trpc/types/attestation-record.types';
import type { GetPolicyAttestationRecordsForDocumentQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetPolicyAttestationRecordsForDocumentDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetPolicyAttestationRecordsForDocument = createQueryHook<
  { documentFileId?: string },
  PolicyAttestationRecordsForDocumentResponseRow[],
  GetPolicyAttestationRecordsForDocumentQuery
>({
  trpcQueryOptions: (trpc, { documentFileId }) =>
    trpc.frontend.attestation.recordsForDocument.queryOptions({
      documentFileId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ attestation_record: data }),
  graphqlDocument: GetPolicyAttestationRecordsForDocumentDocument,
  graphqlVariables: ({ documentFileId }) => ({ documentFileId }),
});
